import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { HttpHeaders, HttpClient, HttpErrorResponse } from '@angular/common/http';
import {environment} from 'src/environments/environment';
import { EnvironmentConfiguration } from '../environment/services/environment.configuration';

var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
var httpOptions;
if (isIEOrEdge) {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache',
      'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
    })
  };
} else {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': localStorage.getItem('Ebom_accessToken')
    })
  };
}

@Injectable({
  providedIn: 'root'
})
export class VersionAddDialogService {

  [x: string]: any;
  version = '/getVersionType/{proxy+}';
  versionQual = '/getVersionQualifierByType/{proxy+}';
  versionRevision = '/getVersionRevisionAdd/{proxy+}';
  priority = '/getPriority/{proxy+}'
  VolumeCountStatus = '/getVolumeCountStatus/{proxy+}';
  addVersion='/addVersions/{proxy+}'
  verRevAdd='/getVerRevAdd/{proxy+}'

  constructor(private http: HttpClient, private environment: EnvironmentConfiguration) { }

getVersTypdropdown(): Observable<any> {
   var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
   let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
  const url= this.environment.Mastersearchdropdown1apiUrl + this.version+'?screenNo=NBPC_10105'+'&fileName=' +fileName
  return this.http.get(url, httpOptions)
    .pipe(
      map((res: any) => res),
      catchError(this.handleError)
    );
}

getVersqualidropdown(bomVerTypeId): Observable<any> {
   var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
  const url= this.environment.Mastersearchdropdown1apiUrl + this.versionQual + '?bomVerTypeId=' +bomVerTypeId+'&screenNo=NBPC_10105'+'&fileName=' +fileName
  return this.http.get(url, httpOptions)
    .pipe(
      map((res: any) => res),
      catchError(this.handleError)
    );
}

getVersrevisdropdown(bomVerTypeId,bomVerQualId): Observable<any> {
   var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
  const url= this.environment.BusinesssearchdropdownapiUrl + this.versionRevision  + '?bomVerTypId=' + bomVerTypeId+'&screenNo=NBPC_10105'+'&fileName=' +fileName
   + '&bomVerQualId=' + bomVerQualId + "&option=" + 'ADD'
  return this.http.get(url, httpOptions)
    .pipe(
      map((res: any) => res),
      catchError(this.handleError)
    );
}

getPrioritydropdown(): Observable<any> {
   var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
  const url= this.environment.BusinesssearchdropdownapiUrl + this.priority+'?screenNo=NBPC_10105'+'&fileName=' +fileName
  return this.http.get(url, httpOptions)
    .pipe(
      map((res: any) => res),
      catchError(this.handleError)
    );
}

getVolcountdropdown(): Observable<any> {
   var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
  const url= this.environment.BusinesssearchdropdownapiUrl+ this.VolumeCountStatus+'?screenNo=NBPC_10105'+'&fileName=' +fileName
  return this.http.get(url, httpOptions)
    .pipe(
      map((res: any) => res),
      catchError(this.handleError)
    );
}

addVersions(body): Observable<any> {
   var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
  const url= this.environment.BusinessActionRestapiUrl + this.addVersion
  return this.http.post(url,body, httpOptions)
    .pipe(
      map((res: any) => res),
      catchError(this.handleError)
    );
}

getVerRev(bomVerQualId,bomVerStatTyp,bomVerNbr): Observable<any> {
   var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
  const url= this.environment.BusinessActionRestapiUrl + this.verRevAdd + '?bomVerQualId=' + bomVerQualId
  + '&bomVerStatTyp=' + bomVerStatTyp + '&bomVerNbr=' + bomVerNbr+'&screenNo=NBPC_10105'+'&fileName=' +fileName
  return this.http.get(url, httpOptions)
    .pipe(
      map((res: any) => res),
      catchError(this.handleError)
    );
}

 // ===================================== Exception Handler ===========================================
 private handleError(error: HttpErrorResponse) {
  var errorMsg = '';
  if (error.error instanceof ErrorEvent) {
    //A client-side or network error occurred. Handle it accordingly.
    errorMsg = `An error occurred: ${error.error.message}`;
  } else {
    //The backend returned an unsuccessful response code.
    //The response body may contain clues as to what went wrong,
    errorMsg = `Backend returned code ${error}`;
  }
  //return an observable with a user-facing error message
  return throwError(errorMsg);
}
}

